/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { IGetSchoolsSuccess, IGetSchoolsFailure } from "./SchoolDataAction";
import { SCHOOLDATA_LOAD_SUCCESS, SCHOOLDATA_LOAD_FAILURE } from "../../Constants/ActionTypes";
import { ISchoolDataState } from "../../Interfaces/SiteContent";

const intialState: ISchoolDataState = {
  schools: [],
  schoolOptionList: [],
  schoolDataLoadError: "",
};

/**
 *
 * @param state
 * @param action
 */
const applyLoadSchools = (
  state: ISchoolDataState,
  action: IGetSchoolsSuccess
): ISchoolDataState => ({
  ...state,
  schools: action.schools,
  schoolOptionList: action.schools.map((x) => ({
    key: x.schoolName,
    name: x.schoolName,
    id: x.schoolId,
    countryRegionId: x.countryRegionId,
  })),
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadFailSchools = (
  state: ISchoolDataState,
  action: IGetSchoolsFailure
): ISchoolDataState => ({
  ...state,
  schoolDataLoadError: action.schoolDataLoadError,
});

/**
 *
 * @param state
 * @param action
 */
function schoolDataReducer(state: ISchoolDataState = intialState, action) {
  switch (action.type) {
    case SCHOOLDATA_LOAD_SUCCESS:
      return applyLoadSchools(state, action);
    case SCHOOLDATA_LOAD_FAILURE:
      return applyLoadFailSchools(state, action);
    default:
      return state;
  }
}

export default schoolDataReducer;
